"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChainId = void 0;
const networks_1 = __importDefault(require("./networks"));
const getChainId = (chainNameOrAlias) => {
    if (networks_1.default.hasOwnProperty(chainNameOrAlias)) {
        return networks_1.default[chainNameOrAlias].chain_id;
    }
    // Iterate through networks to check aliases
    for (const key in networks_1.default) {
        if (networks_1.default.hasOwnProperty(key)) {
            const chain = networks_1.default[key];
            if (chain.chain_aliases &&
                chain.chain_aliases.includes(chainNameOrAlias)) {
                return chain.chain_id;
            }
        }
    }
    return null;
};
exports.getChainId = getChainId;
